import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import ListHeader from './ui/ListHeader';
import LocationParentsView from './ui/LocationParentsView';
import SortTable from './ui/SortTable';
import PaginationButtons from './PaginationButtons';

import config from './../config';
import helpers from './../lib/helpers';

class PersonGroupsList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			nextUrl: null,
			previousUrl: null,
			resultCount: 0,
			loading: true
		};
	}

	componentDidMount() {
		if (this.props.personId || this.props.searchParams || this.props.groupId) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.personId != prevProps.personId || this.props.groupId != prevProps.groupId || this.props.searchParams != prevProps.searchParams) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			loading: true,
			data: null
		});

		let urlParams = [];

		if (this.props.personId) {
			urlParams.push('person='+this.props.personId)
		}

		if (this.props.groupId) {
			urlParams.push('group='+this.props.groupId)
		}

		if (this.props.searchParams) {
			let params = helpers.parseSearchParams(this.props.searchParams)

			if (params.nafn) {
				urlParams.push('name='+params.nafn)
			}

			if (params.sida) {
				urlParams.push('limit='+config.pageSize);
				urlParams.push('offset='+(config.pageSize*(params.sida-1)))
			}

			if (params.rodun) {
				urlParams.push('order='+params.rodun)
			}
		}

		helpers.fetch(config.apiRoot+'/api/groups/persons/?'+urlParams.join('&'), (json) => {
			if (json) {
				this.setState({
					data: json.results,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultCount: json.count
				});

				if (this.props.onResponse) {
					this.props.onResponse(json.results);
				}
			}
			this.setState({
				loading: false
			});
		});
	}

	render() {
		let data = this.state.data;

		return <div className={'position-relative '+(this.props.className || '')+(this.state.loading ? ' loading' : '')}>
			<LoadingBar />
			{
				this.props.enableFilter &&
				<ListFilter filters={[
					{
						label: 'Nafn',
						paramName: 'nafn',
						type: 'text'
					}
				]}
				onFilter={(event) => {
					this.props.history.push(this.props.history.location.pathname+helpers.updateSearchParams(this.props.searchParams, event));
				}} />
			}
			{
				this.props.children
			}
			{
				data && data.length > 0 &&
				<React.Fragment>
					<ListHeader resultCount={this.state.resultCount} />
					<SortTable searchParams={this.props.searchParams} headers={[
							{
								label: 'Nafn',
								sortValue: 'person__name'
							},
							{
								label: 'Staða',
								sortValue: 'status__name'
							},
							{
								label: 'Frá',
								sortValue: 'date_from'
							},
							{
								label: 'Til',
								sortValue: 'date_to'
							}
						]}
					>
						{
							data.map((item, index) => <tr key={index}>
								<td>
									{
										this.props.personId &&
										<Link to={helpers.routerUrls['hopar']+item.group.id}>
											{
												item.group.name
											}
										</Link>
									}
									{
										this.props.groupId &&
										<React.Fragment>
											{
												item.person.file && item.person.file.path &&
												<img style={{
													maxHeight: '30px',
													marginRight: '20px'
												}} src={config.mediaUrl+item.person.file.path} />
											}
											<Link to={helpers.routerUrls['einstaklingar']+item.person.id}>
												{
													item.person.name
												}
											</Link>
										</React.Fragment>
									}
								</td>
								{
									this.props.locationId &&
									<td>
										{
											(item.person.date_of_birth || item.person.date_of_death) &&
											<React.Fragment>{helpers.formatDate(item.person.date_of_birth, true)+'–'+helpers.formatDate(item.person.date_of_death, true)}</React.Fragment>
										}
									</td>
								}
								<td>{helpers.metadataList(item.status, '/einstaklingar/?stada=', 'id', 'name')}</td>
								<td>{
									item.date_from &&
									<React.Fragment>{helpers.formatDate(item.date_from, true)}</React.Fragment>
								}</td>
								<td>{
									item.date_to &&
									<React.Fragment>{helpers.formatDate(item.date_to, true)}</React.Fragment>
								}</td>
							</tr>)
						}
					</SortTable>

					{
						this.state.resultCount > config.pageSize &&
						<PaginationButtons resultCount={this.state.resultCount}
							previousUrl={this.state.previousUrl}
							nextUrl={this.state.nextUrl} />
					}
				</React.Fragment>
			}
		</div>
	};
}

export default PersonGroupsList;
